import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchPracticePhotos = createAsyncThunk(
  "fetchPracticePhotos",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/photos`
    );
    return result;
  }
);

export const fetchDeletePhotoFromCurrentLocation = createAsyncThunk(
  "fetchDeletePhotoFromCurrentLocation",
  async ({ practiceId, imageId, data = [] }) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/practices/${practiceId}/photos/${imageId}?filter-by=practice`,
      data
    );
    return result;
  }
);

export const fetchDeletePhotosFromAllLocation = createAsyncThunk(
  "fetchDeletePhotosFromAllLocation",
  async ({ practiceId, imageId }) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/practices/${practiceId}/photos/${imageId}?filter-by=providers`
    );
    return result;
  }
);

export const fetchPracticeProvidersName = createAsyncThunk(
  "fetchPracticeProvidersName",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/providers?view=provider-name`
    );
    return result;
  }
);

export const fetchAddPracticePhotosWithoutProviders = createAsyncThunk(
  "fetchAddPracticePhotosWithoutProviders",
  async ({ practiceId, data }) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/practices/${practiceId}/photos?media-tag=portal`,
      data
    );
    return result;
  }
);

export const fetchAddPracticePhotosWithProviders = createAsyncThunk(
  "fetchAddPracticePhotosWithProviders",
  async ({ practiceId, providerId, data }) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/practices/${practiceId}/photos/?media-tag=portal&providerDisplayId=${providerId}`,
      data
    );
    return result;
  }
);

export const fetchUpdateImageInformation = createAsyncThunk(
  "fetchUpdateImageInformation",
  async ({ practiceId, imageId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/photos/${imageId}`,
      data
    );
    return result;
  }
);
